import { isValidElement } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const Spinner = () => (
  <div className="flex items-center justify-center min-h-[40vh]">
    <svg className="h-8 w-8 text-[#282E6A] animate-spin" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
    </svg>
  </div>
);

const ProtectedRoute = ({ children, mentorOnly = false }) => {
  const { user, isAuthenticated, isValidating } = useAuth();
  const isMentor = user?.is_mentor === true;

  // Wait for token validation before deciding to redirect
  if (isValidating) return <Spinner />;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (mentorOnly && !isMentor) {
    return <Navigate to="/calendar" replace />;
  }

  if (isValidElement(children)) return children;

  return isMentor
    ? children?.mentor ?? children?.default ?? null
    : children?.student ?? children?.default ?? null;
};

export default ProtectedRoute;
